/* eslint-disable import/extensions */
import getEnvVar from '@/utils/getEnvVar';

const WALKME_BASE = 'https://eu-cdn.walkme.com/users/31958a06a6f0439a8fc7858872f7f4da';
const TEST_ENVS = ['dev1', 'dev2', 'test', 'playground'];

// Each app tier loads a distinct WalkMe CDN snippet; keep these in sync with the WalkMe editor.
const WALKME_SNIPPET = {
  test: `${WALKME_BASE}/test/walkme_31958a06a6f0439a8fc7858872f7f4da_https.js`,
  staging: `${WALKME_BASE}/staging/walkme_31958a06a6f0439a8fc7858872f7f4da_https.js`,
  prod: `${WALKME_BASE}/walkme_31958a06a6f0439a8fc7858872f7f4da_https.js`,
} satisfies Record<string, string>;

const resolveWalkMeSrc = (cubeApiUrl: string): string => {
  if (cubeApiUrl.includes('staging')) return WALKME_SNIPPET.staging;
  if (TEST_ENVS.some(env => cubeApiUrl.includes(env))) return WALKME_SNIPPET.test;
  return WALKME_SNIPPET.prod; // prod cube URL carries no environment substring
};

const insertWalkMeScript = (src: string) => {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const walkMe = document.createElement('script');
    walkMe.type = 'text/javascript';
    walkMe.async = true;
    walkMe.src = src;

    const scripts = document.getElementsByTagName('script');
    const firstScript = scripts[0];

    // If no script tags exist yet, append to head
    if (!firstScript || !firstScript.parentNode) {
      document.head.appendChild(walkMe);
      return;
    }
    // Otherwise, insert before the first script tag
    firstScript.parentNode.insertBefore(walkMe, firstScript);
  } catch (error) {
    // bail silently, we don't want to break the app if WalkMe fails to load
  }
};

export const loadWalkMeScript = () => {
  if (window.location.origin.includes('localhost')) return;

  const cubeApiUrl = getEnvVar('VITE_CUBE_JS_API_URL');
  if (!cubeApiUrl) return;

  insertWalkMeScript(resolveWalkMeSrc(cubeApiUrl));
};
